if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, MediaUpload, RichText } = window.wp.editor;
    const { PanelBody, Button, TextControl } = window.wp.components;

    registerBlockType('custom-gutenberg/activity', {
        title: 'Activity',
        description: 'Experience with an image, label, heading and description.',
        icon: 'format-image',
        category: 'custom-content',
        example: {},

        attributes: {
            image: { type: 'string', default: '' },
            imageId: { type: 'number', default: 0 },
            alt: { type: 'string', default: '' },
            label: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            text: { type: 'string', default: '' }
        },

        edit({ attributes, setAttributes }) {
            const { image, imageId, alt, label, title, text } = attributes;

            function onSelectImage(image) {
                const full = image.sizes && image.sizes.full;
                setAttributes({ image: full ? full.url : image.url, imageId: image.id, alt: image.alt || '' });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Image">
                        <MediaUpload
                            onSelect={ onSelectImage }
                            type="image"
                            allowedTypes={ ['image'] }
                            value={ imageId }
                            render={ ({ open }) => (
                                <div>
                                    { image && <figure><img src={ image } alt={ alt } /></figure> }
                                    <Button className="button" onClick={ open }>{ image ? 'Replace image' : 'Select image' }</Button>
                                    { image && <Button className="button" onClick={ () => setAttributes({ image: '', imageId: 0, alt: '' }) }>Remove image</Button> }
                                </div>
                            ) }
                        />
                        <TextControl label="Image description" value={ alt } onChange={ alt => setAttributes({ alt: alt }) } />
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className="activity-item">
                    <div className="img cover-image bg-dark" style={ image ? { backgroundImage: `url(${image})` } : undefined }></div>
                    <div className="activity-text">
                        <RichText tagName="span" value={ label } placeholder="01 / 03" onChange={ label => setAttributes({ label: label }) } />
                        <RichText tagName="h3" value={ title } placeholder="Naziv doživljaja" onChange={ title => setAttributes({ title: title }) } />
                        <RichText tagName="p" value={ text } placeholder="Opis doživljaja" onChange={ text => setAttributes({ text: text }) } />
                    </div>
                </div>
            ]);
        },

        save({ attributes }) {
            const { image, alt, label, title, text } = attributes;

            return (
                <div className="activity-item">
                    <div className="img cover-image lozad bg-dark" data-background-image={ image || undefined } role={ image && alt ? 'img' : undefined } aria-label={ image && alt ? alt : undefined } aria-hidden={ image && alt ? undefined : true }></div>
                    <div className="activity-text">
                        <RichText.Content tagName="span" value={ label } />
                        <RichText.Content tagName="h3" value={ title } />
                        <RichText.Content tagName="p" value={ text } />
                    </div>
                </div>
            );
        }
    });
}
